//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services.js";
import ProductDistributionTab from "@/pages/FlashReport/components/ProductDistributionTab.vue";
import GeneralViewTab from "@/pages/FlashReport/components/GeneralViewTab.vue";
import * as d3 from "d3";
import CalendarServices from "@/services/calendar-services.js";
import d3Locale from "d3-format/locale/en-US.json";
import { EventBus } from "@/event-bus.js";
import LabelsDialog from "@/components/RightDrawer/LabelsDialog.vue";

export default {
  name: "FlashReport",
  components: {
    ProductDistributionTab,
    GeneralViewTab,
    LabelsDialog,
  },
  props: ["secTab"],
  async beforeMount() {
    BackendServices.getSalesFieldList().then((response) => {
      this.fields = response.data;
      this.fieldId = response.data[0].id;
    });

    this.updateFixedDateMetrics();
  },
  mounted: async function () {
    d3Locale.thousands = " ";
    d3Locale.nan = "N/A";
    d3.formatDefaultLocale(d3Locale);
    BackendServices.getRetailers().then((response) => {
      this.retailerList = response.data;
    });

    BackendServices.getSalesFieldList().then((response) => {
      this.fields = response.data;
      this.fieldId = response.data[0].id;
    });

    let employeeResponse = await BackendServices.getRawEmployees();
    this.employeeList = employeeResponse.data

    this.$store.commit("setDatePickerState", false);
  },
  data: () => ({
    moment,
    d3,
    CalendarServices,
    runningRequests: 0,
    seamlessLabels: false,
    isShowingSpinner: false,
    startDate: moment("2020-04-02", "YYYY-MM-DD"),
    endDate: moment("2020-04-02", "YYYY-MM-DD"),
    fields: [],
    fieldId: null,
    retailerList: [],
    selectedRetailer: null,
    fixedDateMetrics: {
      mtd: {
        current: null,
        ppr: null,
        py: null,
      },
      ytd: {
        current: null,
        ppr: null,
        py: null,
      },
    },
    fixedMetricsLoading: false,
    productHierarchyElementId: null,
    storeHierarchyElementId: null,
    geoHierarchyElementId: null,
    productIds: null,
    storeIds: null,
    employeeIds: null,
    employeeList: [],
  }),
  methods: {
    clearData: function () {
      EventBus.$emit("clear-dashboard");
      this.selectedRetailer = null;
    },
    expandDrawer: function () {
      this.seamlessLabels = true;
      this.$store.commit("toggleRightDrawer");
    },
    // updateSelectedRetailer(element) {
    //   this.storeHierarchyElementId = element;
    //   this.$store.state.selectedFilters.store.hierarchy.retalhista = element;
    //   this.$store.mutations.setHierarchyLevel()
    // },
    async updateFixedDateMetrics() {
      this.fixedMetricsLoading = true;
      let response = null;
      if (this.fieldId) {
        response = await BackendServices.kpis.getMonthToDate(
          moment(),
          this.fieldId,
          this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.employeeIds,
          this.selectedRetailer
        );
        this.fixedDateMetrics.mtd = response.data;

        response = await BackendServices.kpis.getYearToDate(
          moment(),
          this.fieldId,
          this.productHierarchyElementId,
          this.storeHierarchyElementId,
          this.geoHierarchyElementId,
          this.productIds,
          this.storeIds,
          this.employeeIds,
          this.selectedRetailer
        );
        this.fixedDateMetrics.ytd = response.data;
      }
      this.fixedMetricsLoading = false;
    },
  },
  computed: {
    selectedMetric() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field ? field.button_label : undefined;
    },
    salesFieldsButtonGroup() {
      return this.fields.map((i) => ({
        label: i.button_label !== null ? i.button_label : '',
        value: i.id
      }));
    },
    kpiUnits() {
      const filteredFields = this.fields.filter((i) => i.id === this.fieldId);
      const field = filteredFields.pop();
      return field ? field.unit_label : undefined;
    },
    selectedRetailerName: function () {
      let retailer = this.retailerList
        .filter((i) => i.id === this.selectedRetailer)
        .pop();
      return retailer ? retailer.name : null;
    },
    employeeName: function () {
      if (this.employeeIds == null) {
        return null;
      }
      let result = '';
      let filteredEmployees = this.employeeList
        .filter((i) => this.employeeIds.includes(i.id));
      if (filteredEmployees.length > 0) {
        for (let i = 0; i < filteredEmployees.length; i++) {
          result += filteredEmployees[i].name + ', '
        }
        result = result.substring(0, result.length - 2)
      }
      return result
    },
  },
  watch: {
    selectedRetailer: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    productHierarchyElementId: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    storeHierarchyElementId: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    geoHierarchyElementId: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    fieldId: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    productIds: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    storeIds: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    employeeIds: {
      immediate: true,
      handler: function () {
        this.updateFixedDateMetrics();
      },
    },
    "$store.getters.getSelectedRetailers": {
      immediate: true,
      deep: true,
      handler: function () {
        this.selectedRetailer = this.$store.getters.getSelectedRetailers;
      },
    },
    "$store.getters.getProductHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let productHierarchy = Object.values(
          this.$store.getters.getProductHierarchy
        ).filter((i) => i.length > 0);
        this.productHierarchyElementId =
          productHierarchy[productHierarchy.length - 1];
      },
    },
    "$store.getters.getStoreHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let storeHierarchy = Object.values(
          this.$store.getters.getStoreHierarchy
        ).filter((i) => i.length > 0);
        this.storeHierarchyElementId =
          storeHierarchy[storeHierarchy.length - 1];
      },
    },
    "$store.getters.getGeographyHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let geoHierarchy = Object.values(
          this.$store.getters.getGeographyHierarchy
        ).filter((i) => i.length > 0);
        this.geoHierarchyElementId = geoHierarchy[geoHierarchy.length - 1];
      },
    },
    "$store.getters.getDateRange": {
      immediate: true,
      deep: true,
      handler: function () {
        let { from, to } = this.$store.getters.getDateRange;
        this.startDate = moment(from, "YYYY/MM/DD");
        this.endDate = moment(to, "YYYY/MM/DD");
      },
    },
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.productIds) {
          this.productIds = [];
        }
        if (this.$store.getters.getProductList.length) {
          this.productIds.splice(
            0,
            this.productIds.size,
            ...this.$store.getters.getProductList
          );
        } else {
          this.productIds = null;
        }
        //TODO => ver splice! (havia bug no cardex e suspeita-se que aqui tmb)
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.storeIds) {
          this.storeIds = [];
        }

        if (this.$store.getters.getStoreList.length) {
          this.storeIds.splice(
            0,
            this.storeIds.size,
            ...this.$store.getters.getStoreList
          );
        } else {
          this.storeIds = null;
        }
      },
    },
    "$store.getters.getEmployeeList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.employeeIds) {
          this.employeeIds = [];
        }

        if (this.$store.getters.getEmployeeList.length) {
          this.employeeIds = [...this.$store.getters.getEmployeeList]
        } else {
          this.employeeIds = null;
        }
      },
    },
  },
};
